'use strict';

var Alarm = require('utils/alarm');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var AbstractTableView = require('components/common/views/abstract_table_view');
var Misc = require('utils/misc');
var Notification = require('utils/notification');

var templates = Misc.templateSet(require('components/devices/templates/alarm/alarm_list'));

var AlarmConfigList = AbstractTableView.extend({
    controller: undefined,

    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click #js-add': 'add',
            'click a.js-configure-alarm': 'edit',
            'click input.js-table-row-select': 'selectionChanged',
            'click #js-toggle': 'toggle',
        });
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.collection = options.collection;
        this.ownerID = options.ownerID;
        this.ownerDevice = options.ownerDevice;

        AbstractTableView.prototype.initialize.apply(this, [this.getTableConfiguration()]);
    },

    setPermission: function (pemissions) {
        // do nothing -> no read-only-mode
    },

    onShow: function () {
        this.updateSelectionButtonsLabel();
    },

    onRender: function () {
        AbstractTableView.prototype.onRender.apply(this);
        this.updateSelectionRows();
        this.updateSelectionButtons();
        this.updateSelectionButtonsLabel();
    },

    getTableConfiguration: function () {
        return {
            title: i18n.TR('Alarmkonfiguration'),
            columns: [
                { id: '#_name', name: i18n.TR('Name'), displayMethod: 'name', alwaysVisible: true }, // i18n.TR('Name')
                { id: '#_devices', name: i18n.TR('Geräte'), displayMethod: 'devices' }, // i18n.TR('Geräte')
                { id: '#_trigger_time', name: i18n.TR('Benachrichtigung'), displayMethod: 'triggerTime' }, // i18n.TR('Benachrichtigung')
                { id: '#_conditions', name: i18n.TR('Bedingung'), displayMethod: 'conditions' }, // i18n.TR('Fehler')
            ],
            hasRefreshButton: true,
            hasSelectionButtons: true,
            selectionButtons: [
                { ButtonText: i18n.TR('Aktivieren'), ButtonID: 'toggle' },
                { ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' },
            ],
            customButtons: [
                {
                    ButtonIcon: 'fa fa-plus',
                    ButtonID: 'add',
                },
            ],
            displayMethods: {
                name: function (value, model) {
                    return templates.name({
                        model: model,
                        priority_text: Alarm.getPriorityText(model.priority),
                    });
                },
                devices: function (value, model) {
                    if (value && value.length) {
                        return Handlebars.helpers.COMPACT_DEVICE_LIST(value, model.device_count);
                    }
                    return AppState.filterToStr(model.filter);
                },
                triggerTime: function (value, model) {
                    return templates.trigger({
                        time: new Handlebars.SafeString(Alarm.getAlarmTime(value, i18n.TR('sofort'))),
                        model: model,
                    });
                },
                conditions: function (value, model) {
                    var isInvalid = false;

                    var checkField = function (fld) {
                        if (!fld) return true;
                        if (AppState.availableColumnData(fld)) return true;
                        if (fld == Consts.AlarmStatusField && AppState.availableColumnData('status')) return true;
                        return false;
                    };

                    _.each(value, function (c) {
                        if (!checkField(c.line1) || !checkField(c.line2)) {
                            isInvalid = true;
                        }
                    });

                    if (isInvalid) {
                        return i18n.TR('Nicht verfügbar');
                    }

                    var lines = _.map(value, function (x) {
                        return Alarm.getConditionText(x, true, model);
                    });
                    return templates.condition(lines);
                },
            },
        };
    },

    add: function () {
        this.controller.showDialogByOwner(this.ownerID, this.ownerDevice);
    },

    edit: function (e) {
        e.preventDefault();
        var modelID = $(e.currentTarget).attr('data-idx');
        var model = this.collection.get(modelID);
        if (!model.attributes.can_edit) {
            Notification.show('error', i18n.TR('Hinweis'), i18n.TR('Nur deaktivierte Alarme können geändert werden.'));
            return;
        }

        this.controller.showDialog($(e.currentTarget).attr('data-idx'), this.ownerID, this.ownerDevice);
    },

    selectionChanged: function (e) {
        this.rowSelected(e);
        this.updateSelectionButtonsLabel();
    },

    nrSelectedInactiveAlarms: function () {
        return _.filter(this.collection.selected, function (a) {
            return !a.get('is_active');
        }).length;
    },

    // overwrite default AbstractTableView implementation -> consider active alarms
    deleteSelectedRows: function (e) {
        this.controller.delete(this.collection);
    },

    updateSelectionButtonsLabel: function () {
        $('.js-tab-btn-toggle').html(
            this.nrSelectedInactiveAlarms() > 0 || this.collection.selectedLength == 0
                ? '<i class="fa fa-check-square-o m-r-5"></i>' + i18n.TR('Aktivieren')
                : '<i class="fa fa-square-o m-r-5"></i>' + i18n.TR('Deaktivieren')
        );
    },

    toggle: function () {
        var self = this;
        this.controller.setActive(this.collection.selected, this.nrSelectedInactiveAlarms() > 0, function () {
            self.collection.fetch({
                success: function () {
                    self.collection.updateCanEdit();
                    self.render();
                },
                error: function () {
                    Notification.show(
                        'warning',
                        i18n.TR('Warnung'),
                        i18n.TR('Einstellungen konnten nicht gespeichert werden.')
                    );
                },
            });
        });
    },
});

module.exports = AlarmConfigList;
